import React from 'react';

import { Components } from '../../Android/Components';
import SystemFrameworksDatatable from '../../iOS/SystemFrameworksDatatable';

export const V1_5 = ({ platform }) =>
  platform === 'android' ? <Components /> : <SystemFrameworksDatatable />;
